// extracted by mini-css-extract-plugin
export default {"root":"_2MVARJZtZDaHzpMVh0UAfo","size":"_1_ErB7Ycb-gSjPZrW9M3se"};